module.exports = __webpack_public_path__ + "static/curso_alta_montana-46775ceff161d780c6a932912339f6c4.jpg";